import { render, staticRenderFns } from "./HeadlineLead.vue?vue&type=template&id=4357275f&"
import script from "./HeadlineLead.vue?vue&type=script&lang=ts&"
export * from "./HeadlineLead.vue?vue&type=script&lang=ts&"
import style0 from "./HeadlineLead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports